import { render, staticRenderFns } from "./subsets-statistics.vue?vue&type=template&id=060018a0"
import script from "./subsets-statistics.vue?vue&type=script&lang=js"
export * from "./subsets-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports